import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator,
} from "../components/ui/breadcrumb";
import {Project} from "@models/project";
import React, {useContext} from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {UserContext} from "../contexts/UserContext";
import {CompanyType} from "../models/company";

type projectProps = {
    project?: Project;
};

export function HighlightedLink({
                                    to,
                                    children,
                                    state
                                }: {
    to: string;
    children: React.ReactNode;
    state?: { project?: Project };
}) {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <Link state={state} to={to} className={isActive ? "text-gray-900 border-b-2 border-gray-900" : ""}>
            {children}
        </Link>
    );
}

export const ProjectBreadCrumb = ({project}: projectProps) => {
    const navigate = useNavigate();
    const {project_id, bid_id} = useParams<string>();
    const userContext = useContext(UserContext);
    const this_project = userContext?.projects.find(item => item.project_id === project_id);
    return (
        <nav>
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink>
                            <button onClick={() => navigate(-1)}>Back</button>
                        </BreadcrumbLink>
                    </BreadcrumbItem>

                    |
                    <BreadcrumbItem>
                        <HighlightedLink to="/">Home</HighlightedLink>
                    </BreadcrumbItem>
                    {project_id ? (
                        <>
                            <BreadcrumbSeparator/>
                            <BreadcrumbItem>
                                <HighlightedLink to={`/project/${project_id}`}>
                                    Project
                                </HighlightedLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator/>
                            <BreadcrumbItem>
                                <HighlightedLink to={`/project/${project_id}/bidders`}>
                                    Bids
                                </HighlightedLink>
                            </BreadcrumbItem>
                            |
                            <BreadcrumbItem>
                                <HighlightedLink to={`/project/${project_id}/ve`}>
                                    VE
                                </HighlightedLink>
                            </BreadcrumbItem>
                            |
                            <BreadcrumbItem>
                                <HighlightedLink
                                    to={`/project/${project_id}/documents`}
                                >
                                    Files
                                </HighlightedLink>
                            </BreadcrumbItem>
                            |
                            {this_project?.scopes_enabled &&
                                <>
                                    <BreadcrumbItem>
                                        <HighlightedLink
                                            to={`/project/${project_id}/scopes`}
                                        >
                                            Scopes
                                        </HighlightedLink>
                                    </BreadcrumbItem>
                                    |
                                </>
                            }
                            <BreadcrumbItem>
                                <HighlightedLink
                                    to={`/project/${project_id}/qa`}
                                >
                                    Questions/Answers
                                </HighlightedLink>
                            </BreadcrumbItem>
                            |
                            <BreadcrumbItem>
                                <HighlightedLink
                                    to={`/project/${project_id}/directory`}
                                >
                                    Directory
                                </HighlightedLink>
                            </BreadcrumbItem>
                            {
                                // userContext?.company_type === CompanyType.developer
                                this_project?.role === CompanyType.developer
                                    ? <>|
                                        <BreadcrumbItem>
                                            <HighlightedLink
                                                to={`/project/${project_id}/config`}
                                                state={{project: project}}
                                            >
                                                Settings
                                            </HighlightedLink>
                                        </BreadcrumbItem>
                                    </>
                                    : <>|
                                    <BreadcrumbItem>
                                            <HighlightedLink
                                                to={`/project/${project_id}/config`}
                                                state={{project: project}}
                                            >
                                                Info
                                            </HighlightedLink>
                                        </BreadcrumbItem>
                                    </>
                            }
                        </>
                    ) : (
                        <>
                            |
                            <BreadcrumbItem>
                                <HighlightedLink
                                    to={`company/directory`}
                                >
                                    Directory
                                </HighlightedLink>
                            </BreadcrumbItem>
                            |
                            <BreadcrumbItem>
                                <HighlightedLink
                                    to={`/company/profile`}
                                >
                                    Profile
                                </HighlightedLink>
                            </BreadcrumbItem>
                        </>
                    )}
                </BreadcrumbList>
            </Breadcrumb>
            <br/>
        </nav>
    );
};
